<!--
// app/pages/how-to-play.vue
-->
<script setup lang="ts">
import { useNuxtApp } from "#imports";
import HtpHero from "~/components/pages/how-to-play/HtpHero.vue";
import HtpSectionIndex from "~/components/pages/how-to-play/HtpSectionIndex.vue";
import HtpSectionDuration from "~/components/pages/how-to-play/HtpSectionDuration.vue";
import HtpSectionSecretCards from "~/components/pages/how-to-play/HtpSectionSecretCards.vue";
import HtpSectionTimeline from "~/components/pages/how-to-play/HtpSectionTimeline.vue";
import HtpSectionSanctions from "~/components/pages/how-to-play/HtpSectionSanctions.vue";
import HtpSectionChrono from "~/components/pages/how-to-play/HtpSectionChrono.vue";

const { $t } = useNuxtApp();

definePageMeta({
  middleware: ["not-found-queens"],
});

useSeoMeta({
  title: $t("howToPlay.meta.title"),
  description: $t("howToPlay.meta.description"),
  ogTitle: $t("howToPlay.meta.title"),
  ogDescription: $t("howToPlay.meta.description"),
});
</script>

<template>
  <div class="min-h-screen">
    <HtpHero />
    <HtpSectionIndex />

    <!-- Sections -->
    <div class="kql-w-container px-6 bigsm:px-12 py-6 md:py-20 space-y-16">
      <div class="flex justify-center">
        <iframe
          width="100%"
          height="auto"
          src="https://www.youtube-nocookie.com/embed/cQKfuedbXMs?si=vHfMaRxjPhv1Ecxc"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
          class="max-w-screen-md aspect-video"
        ></iframe>
      </div>
      <HtpSectionDuration />
      <HtpSectionSecretCards />
      <HtpSectionTimeline />
      <HtpSectionSanctions />
      <HtpSectionChrono />
    </div>
  </div>
</template>

<style scoped></style>
